import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IResetPasswordParams {
  resetToken: string;
  newEncryptedPassword: string;
  encryptionKeyId: string;
}

export class ResetPasswordRequest extends Request<IResetPasswordParams, IResult> {
  constructor(params: IResetPasswordParams) {
    super('resetPassword', params);
  }
}
